module.exports = __webpack_public_path__ + "static/prodinity_tablet-a7b270084e08843fd0582beccb6ffeba.png";